module.exports = __webpack_public_path__ + "img/email-icon.b208c851.svg";